import { render, staticRenderFns } from "./DotCarousel.vue?vue&type=template&id=57fd213c&"
import script from "./DotCarousel.vue?vue&type=script&lang=js&"
export * from "./DotCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports